import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";

class GAListener extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    if (!window.ga) return;
    this.routerUnlisten = this.props.history.listen(location => {
      // Report pageview to Google Analytics
      window.ga?.("send", "pageview", location.pathname);
    });

    window.ga?.("send", "pageview", this.props.location.pathname);
  }

  componentWillUnmount() {
    this.routerUnlisten?.();
  }

  render() {
    // eslint-disable-next-line react/prop-types
    return this.props.children;
  }
}

export default withRouter(GAListener);
